import { environment } from '@environments';
import axios from 'axios';
// import Vue from 'vue';
import { logout } from '@/common/preload/auth';
// import { isNeededRecaptcha } from '@/common/recaptcha';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import { captureUnexpectedException } from '@/common/sentry';
import i18n from '@/plugins/i18n';

import store from '../../store';

const interceptor = axios.create({
  // baseURL: process.env.VUE_APP_BACKEND_HOST,
  baseURL: environment.VUE_APP_BACKEND_HOST,
  timeout: Infinity,
});

// const refreshTokenURL = `${process.env.VUE_APP_BACKEND_HOST}/api/v1/auth/token`;
const refreshTokenURL = `${environment.VUE_APP_BACKEND_HOST}/api/v1/auth/token`;

// async function checkRecaptcha(params, attempts = 10) {
//   if (isNeededRecaptcha(params.url)) {
//     if (!Vue.prototype.$recaptcha?.executePromise && attempts > 0) {
//       await new Promise((resolve) => setTimeout(resolve, 400));
//       return await checkRecaptcha(params, --attempts);
//     }
//     if (!Vue.prototype.$recaptcha.executePromise) {
//       throw new Error(i18n.t('notifications.captchaError'));
//     }
//     const token = await Vue.prototype.$recaptcha.executePromise();
//     return token;
//   }
//   return null;
// }

function generateRequestId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // RFC4122-ish fallback for older browsers/environments.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

interceptor.interceptors.request.use(
  async (config) => {
    const accessToken = localStorage.getItem('token');
    const sessionId = localStorage.getItem('sessionId');

    const currentUserId = store.state.loggedAccount.account?.id;

    // const reCaptchaToken = await checkRecaptcha(config);

    // if (reCaptchaToken) {
    //   if (config.method === 'get') {
    //     config.params = { ...config.params, recaptcha: reCaptchaToken };
    //   } else if (config.method === 'post') {
    //     if (config.data) config.data.recaptcha = reCaptchaToken;
    //     else config.data = { recaptcha: reCaptchaToken };
    //   }
    // }

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    } else {
      delete interceptor.defaults.headers.common.Authorization;
      delete config.headers.common.Authorization;
    }

    if (currentUserId) {
      config.headers['x-user-id'] = currentUserId;
    }

    if (sessionId) {
      config.headers['X-Session-Id'] = sessionId;
    }

    // Generate a per-request correlation id so backend logs can be grouped with the
    // originating HTTP call. If a caller already set one, respect it.
    if (!config.headers['X-Request-Id']) {
      config.headers['X-Request-Id'] = generateRequestId();
    }

    return config;
  },
  (error) => Promise.reject(error),
);

export const refreshAuthLogic = (failedRequest) => {
  if (!localStorage.getItem('refreshToken')) {
    const errId = failedRequest?.response?.data.errorMessage.errorId;

    if (failedRequest?.response?.status === 401) {
      switch (errId) {
        case 'error_account_username_or_password_is_incorrect':
          return Promise.reject(new Error(i18n.t('errors.incorrectLogin')));
        case 'error_account_is_not_active_please_you_email_link':
          return Promise.reject(new Error(i18n.t('errors.accountNotActive')));
        case 'error_not_possible_to_login_to_deactivated_department':
          return Promise.reject(new Error(i18n.t('errors.notPossibleToLoginToDeactivatedDepartment')));
        default:
          return Promise.reject(new Error('Refresh token is not provided'));
      }
    }

    return Promise.reject(new Error('Refresh token is not provided'));
  }

  return axios
    .post(refreshTokenURL, null, {
      headers: { 'x-refresh-token': localStorage.getItem('refreshToken') },
    })
    .then((res) => {
      localStorage.setItem('token', res.data.payload.accessToken);
      localStorage.setItem('refreshToken', res.data.payload.refreshToken);

      failedRequest.response.config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
      return Promise.resolve();
    })
    .catch((err) => {
      console.log(err);
      captureUnexpectedException(err, failedRequest?.response?.config?.headers?.['X-Request-Id']);
      logout();
    });
};

createAuthRefreshInterceptor(interceptor, refreshAuthLogic);

interceptor.interceptors.response.use(
  (response) => response,
  // (config) => {
  //   createAuthRefreshInterceptor(interceptor, refreshAuthLogic);
  //   return config;
  // },
  async (error) => {
    // Backend signals a hijacked/stale session by returning 401 with this errorId; log
    // the user out so they re-authenticate instead of silently retrying with a bad sid.
    const errId = error?.response?.data?.errorMessage?.errorId
      || error?.response?.data?.message?.errorId;
    if (error?.response?.status === 401 && errId === 'error_session_mismatch') {
      try {
        await logout();
      } catch (_e) {
        // logout is best-effort; we still reject so the caller sees the error.
      }
    }
    return Promise.reject(error);
  },
);

export default interceptor;
